import type { MaybeRef } from "vue"
import type { SlideshowConfig } from "@/models"
import { useMutation } from "@tanstack/vue-query"
import { v1 } from "@/axios"

export interface IUseCreateSlideshowConfigParams {
  slideshowConfig: SlideshowConfig
  eventVaultId: number
}

export async function createSlideshowConfig(slideshowConfig: SlideshowConfig, eventVaultId: number) {
  const request = slideshowConfig.toRequest()

  return v1.post(`/${eventVaultId}/slideshow`, request)
}

export function useCreateSlideshowConfig(eventVaultId?: MaybeRef<number | undefined>) {
  return useMutation({
    mutationKey: ["createSlideshowConfig", eventVaultId],
    mutationFn: ({ slideshowConfig, eventVaultId }: IUseCreateSlideshowConfigParams) =>
      createSlideshowConfig(slideshowConfig, eventVaultId),
  })
}
